import React from 'react';
import type { Workflow } from '../../lib/workflow-types';

interface Props {
  workflow: Workflow;
  onEdit?: (workflow: Workflow) => void;
  onDelete?: (id: string) => void;
  onTrigger?: (id: string) => void;
  onViewRuns?: () => void;
}

export function WorkflowCard({ workflow, onEdit, onDelete, onTrigger, onViewRuns }: Props) {
  return (
    <div className="bg-white border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow">
      <div className="flex justify-between items-start mb-2">
        <div>
          <h3 className="font-semibold text-gray-900">{workflow.name}</h3>
          <span className="text-xs text-gray-500">
            {workflow.trigger.type} trigger
          </span>
        </div>
        <span className="px-2 py-0.5 text-xs bg-blue-100 text-blue-700 rounded">
          {workflow.steps.length} steps
        </span>
      </div>

      {workflow.description && (
        <p className="text-sm text-gray-600 mb-3 line-clamp-2">{workflow.description}</p>
      )}

      <div className="flex flex-wrap gap-1 mb-3">
        {workflow.steps.slice(0, 4).map((step, i) => (
          <span key={step.id} className="px-2 py-0.5 text-xs bg-gray-100 text-gray-600 rounded">
            {step.name}
          </span>
        ))}
        {workflow.steps.length > 4 && (
          <span className="px-2 py-0.5 text-xs bg-gray-100 text-gray-600 rounded">
            +{workflow.steps.length - 4} more
          </span>
        )}
      </div>

      <div className="flex gap-2 pt-2 border-t border-gray-100">
        {onTrigger && (
          <button onClick={() => onTrigger(workflow.id)} className="text-sm text-green-600 hover:text-green-800">
            Run
          </button>
        )}
        {onViewRuns && (
          <button onClick={onViewRuns} className="text-sm text-purple-600 hover:text-purple-800">
            Runs
          </button>
        )}
        {onEdit && (
          <button onClick={() => onEdit(workflow)} className="text-sm text-blue-600 hover:text-blue-800">
            Edit
          </button>
        )}
        {onDelete && (
          <button onClick={() => onDelete(workflow.id)} className="text-sm text-red-600 hover:text-red-800">
            Delete
          </button>
        )}
      </div>
    </div>
  );
}
